import React from 'react';
import { CheckCircleOutline, ReportProblemOutlined, ErrorOutlineOutlined, TimelapseOutlined, PauseCircleOutline } from '@mui/icons-material';

export default function WorkflowRunStatusIcon(props) {
  const iconStyles = { display: 'flex', alignItems: 'center' };
  
  const getStatusIcon = () => {
    switch (props.status) {
      case "Not Started":
        return <PauseCircleOutline alt="not started" fontSize='small' className="iconMarginRight" style={{color: 'var(--dark-gray)'}} />;
      case "In Progress":
        return <TimelapseOutlined alt="in progress" fontSize='small' className="iconMarginRight" style={{color: 'var(--info-color)'}} />;
      case "Completed":
      case "SUCCESS":
        return <CheckCircleOutline alt="completed" fontSize='small' className="iconMarginRight" style={{color: 'var(--success-color)'}} />;
      case "Completed with Warnings":
      case "WARNING":
        return <ReportProblemOutlined alt="warnings" fontSize='small' className="iconMarginRight" style={{color: 'var(--warning-color)'}} />;
      case "Failed":
      case "FAILED":
        return <ErrorOutlineOutlined alt="failed" fontSize='small' className="iconMarginRight" style={{color: 'var(--error-color)'}} />;
      default:
        return null;
    }
  };

  return (
    <span style={iconStyles}>
      {getStatusIcon()}
      {props.children}
    </span>  );
}
